import axios from "axios";

const api = axios.create({
  baseURL: "https://backend.lifeskillglobal.online/api",
  withCredentials: true,
  headers: {
    "Accept": "application/json",
  },
  //   validateStatus: (status) => true, 
});

// Add Authorization header if token exists
api.interceptors.request.use((config) => {
  const token = sessionStorage.getItem('authToken')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config;
})


export const validateUser = (payload) => {
  return api.post("/auth/validate-user", payload)
}
export const register = (payload) => {
  return api.post("/auth/register", payload)
}
export const loginSendOtp = (payload) => {
  return api.post("/auth/send-otp", payload)
}
export const loginVerifyOtp = (payload) => {
  return api.post("/auth/verify-otp", payload)
}
export const forgotPasswordsendOtp = (payload) => {
  return api.post("/auth/forgot-password", payload)
}
export const changePassword = (payload) => {
  return api.post("/auth/reset-password", payload)
}
export const logout = () => {
  return api.post("/auth/logout")
}
export const adminDashboardData = () => {
  return api.get("/admin/dashboard");
};
export const userDashboardData = () => {
  return api.get("/user/dashboard");
};
export const userProfileData = () => {
  return api.get("/user/profile");
};
export const userUpdateProfile = (id, payload) => {
  return api.post(`/user/update-profile/${id}`, payload);
};
export const userMyReferralList = (params = {}) => {
  return api.get("/user/my-referrals", { params });
};

export const adminAllCourseList = (params = {}) => {
  return api.get("/all-courses", { params });
};

export const adminAddCourse = (payload) => {
  return api.post("/admin/add-course", payload);
};
export const adminEditCourse = (id, payload) => {
  return api.post(`/admin/update-course/${id}`, payload);
};
export const adminGetCourseById = (id) => {
  return api.get(`/course/${id}`);
};
export const adminImportCourseList = (formData) => {
  return api.post("/admin/courses/import", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
export const adminExportCourseList = () => {
  return api.get("/admin/courses/export", {
    responseType: "blob",
  });
};
export const adminSendNotifications = (payload) => {
  return api.post("/admin/notifications/send", payload);
};
// export const adminGetUserByCourse = () => {
//   return api.get("/admin/get-users-by-course");
// };

export const adminGetUserByCourse = (courseId) => {
  return api.get("/admin/get-users-by-course", {
    params: { course_id: courseId },
  });
};

export const adminGetAllCommissionConfig = (params = {}) => {
  return api.get("/admin/all-commission-config", { params });
};

export const adminGetCommissionConfig = () => {
  return api.get("/admin/commission-config");
};
export const adminGetCommissionConfigById = (id) => {
  return api.get(`/admin/commission-config/${id}`);
};
export const adminAddCommissionConfig = (payload) => {
  return api.post("/admin/add-commission-config", payload);
};
export const adminEditCommissionConfig = (id, payload) => {
  return api.post(`/admin/update-commission-config/${id}`, payload);
};

export const adminAllLevelCommission = (configId, params = {}) => {
  return api.get(`/admin/all-level-commission/${configId}`, { params });
};

export const adminAddLevelCommission = (payload) => {
  return api.post("/admin/add-level-commission", payload);
};

export const adminEditLevelCommission = (id, payload) => {
  return api.post(`/admin/update-level-commission/${id}`, payload);
};

export const adminGetLevelCommissionById = (id) => {
  return api.get(`/admin/level-commission/${id}`);
};

export const userBuyCourse = (payload) => {
  return api.post("/user/buy-course", payload);
};

export const createCoursePaymentOrder = (payload) => {
  return api.post("/user/payment/create-order", payload);
};

export const verifyCoursePayment = (payload) => {
  return api.post("/user/payment/verify", payload);
};

export const previewCollaborativePurchase = (data) => {
  return api.post("/user/collaborative-purchase/preview", data);
};

export const createCollaborativePurchaseOrder = (data) => {
  return api.post("/user/collaborative-purchase/create-order", data);
};

export const verifyCollaborativePurchasePayment = (data) => {
  return api.post("/user/collaborative-purchase/verify-payment", data);
};

export const getCollaborativePurchaseDetail = (id) => {
  return api.get(`/user/collaborative-purchase/${id}`);
};

export const userLevelEarnings = (params = {}) => {
  return api.get("/user/level-earnings", { params });
};

// export const userLevelNetworkData = (params = {}) => {
//   return api.get("/user/level-network", { params });
// };
export const userLevelNetworkData = (params = {}, config = {}) => {
  return api.get("/user/level-network", { params, ...config });
};

export const userWalletData = (params = {}) => {
  return api.get("/user/user-wallet", { params });
};

export const updateBufferAmount = (data = {}) => {
  return api.post("/user/update-buffer-amount", data);
};

export const userMyPaymentsData = (params = {}) => {
  return api.get("/user/my-payments", { params });
};

// export const downloadInvoice = (transactionId) => {
//   return api.get(`/user/my-payments/${transactionId}/invoice`, {
//     responseType: "blob",
//   });
// };

export const downloadInvoice = (transactionId, type) => {
  return api.get(
    `/user/my-payments/${transactionId}?type=${type}`,
    {
      responseType: "blob",
    }
  );
};

export const userInvoicesList = (params = {}) => {
  return api.get("/user/transactions/invoices", { params });
};

export const downloadUserInvoiceById = (invoiceId) => {
  return api.get(`/user/transactions/invoices/${invoiceId}/download`, {
    responseType: "blob",
  });
};

export const userCreditNotesList = (params = {}) => {
  return api.get("/user/transactions/credit-notes", { params });
};

export const downloadUserCreditNoteById = (creditNoteId) => {
  return api.get(`/user/transactions/credit-notes/${creditNoteId}/download`, {
    responseType: "blob",
  });
};

export const userGstReport = (params = {}) => {
  return api.get("/user/payments/gst", { params });
};

export const userTdsReport = (params = {}) => {
  return api.get("/user/payments/tds", { params });
};

export const adminGstReport = (params = {}) => {
  return api.get("/admin/payments/gst", { params });
};

export const adminTdsReport = (params = {}) => {
  return api.get("/admin/payments/tds", { params });
};

export const adminInvoicesList = (params = {}) => {
  return api.get("/admin/transactions/invoices", { params });
};

export const adminCreditNotesList = (params = {}) => {
  return api.get("/admin/transactions/credit-notes", { params });
};

export const listOfUsers = (params = {}) => {
  return api.get("/admin/list-of-users", { params });
};

export const getSingleUserById = (id) => {
  return api.get(`/admin/user-details/${id}`);
};

export const changeUserStatus = (payload) => {
  return api.post("/admin/change-status", payload);
};

export const adminChangeUserPassword = (id, payload) => {
  return api.post(`/admin/users/${id}/change-password`, payload);
};

export const userMyCourses = (params = {}) => {
  return api.get("/user/my-courses", { params });
};

export const adminAddUser = (payload) => {
  return api.post("/admin/add-user", payload);
};

export const adminUpdateUser = (id, payload) => {
  return api.post(`/admin/update-user/${id}`, payload);
};

export const adminGetTransactionHistory = (params = {}) => {
  return api.get("/admin/transaction-history", { params });
};

export const adminGetTransactionById = (id) => {
  return api.get(`/admin/transaction/${id}`);
};

export const adminGetPaymentConfirmList = (params = {}) => {
  return api.get("/admin/payment-confirm", {
    params,
    paramsSerializer: (params) =>
      new URLSearchParams(
        Object.entries(params).reduce((acc, [key, value]) => {
          acc[key] = value;
          return acc;
        }, {})
      )
        .toString()
        .replace(/\+/g, "%20"),
  });
};

export const adminGetReport = (params = {}) => {
  const query = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      query.append(key, value);
    }
  });

  return api.get(`/admin/reports?${query.toString()}`);
};

export const adminExportReport = (params = {}) => {
  const query = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      query.append(key, value);
    }
  });

  return api.get(`/admin/reports/export?${query.toString()}`, {
    responseType: "blob",
  });
};

export const getWithdrawalHistory = (params = {}) => {
  return api.get("/user/withdraw/history", { params });
};

export const instantWithdraw = (data = {}) => {
  return api.post("/user/withdraw/instant", data);
};

export const withdrawalRequests = (params = {}) => {
  return api.get("/admin/withdrawals", { params });
};
export const adminApproveWithdrawalRequest = (id, data = {}) => {
  return api.post(`/admin/withdrawal/${id}/approve`, data);
};

export const adminRejectWithdrawalRequest = (id, data = {}) => {
  return api.post(`/admin/withdrawal/${id}/reject`, data);
};

export const requestWithdrawal = (data = {}) => {
  return api.post("/user/withdraw/request", data);
};
// api helpers
// export const userGetReport = (params = {}) => {
//   const query = new URLSearchParams();

//   Object.entries(params).forEach(([key, value]) => {
//     if (value !== undefined && value !== null && value !== "") {
//       query.append(key, value);
//     }
//   });

//   const qs = query.toString();
//   return api.get(`/user/level-network-report${qs ? `?${qs}` : ""}`);
// };

// export const userExportReport = (params = {}) => {
//   const query = new URLSearchParams();

//   Object.entries(params).forEach(([key, value]) => {
//     if (value !== undefined && value !== null && value !== "") {
//       query.append(key, value);
//     }
//   });

//   const qs = query.toString();
//   return api.get(`/user/export-level-network-report${qs ? `?${qs}` : ""}`, {
//     responseType: "blob",
//   });
// };

export const userGetReport = (params = {}) => {
  const query = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      query.append(key, value);
    }
  });

  const qs = query.toString();
  return api.get(`/user/level-network-user-report${qs ? `?${qs}` : ""}`);
};

export const userExportReport = (params = {}) => {
  const query = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      query.append(key, value);
    }
  });

  const qs = query.toString();
  return api.get(`/user/export-level-network-user-report${qs ? `?${qs}` : ""}`, {
    responseType: "blob",
  });
};


export const adminCreateBonusSlab = (data = {}) => {
  return api.post("/admin/slab/create", data);
};

export const adminUpdateBonusSlab = (id, data = {}) => {
  return api.post(`/admin/slab/update/${id}`, data);
};

export const adminGetBonusSlabs = (params = {}) => {
  const query = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      query.append(key, value);
    }
  });

  const qs = query.toString();
  return api.get(`/slabs${qs ? `?${qs}` : ""}`);
};

export const adminGetBonusSlabById = (id) => {
  return api.get(`/admin/slab/${id}`);
};

export const adminGetBonusDashboard = (params = {}) => {
  const query = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      query.append(key, value);
    }
  });

  const qs = query.toString();
  return api.get(`/admin/bonus-dashboard${qs ? `?${qs}` : ""}`);
};

export const adminCreateBonusCycle = (data = {}) => {
  return api.post("/admin/cycle/create", data);
};

export const adminUpdateBonusCycle = (id, data = {}) => {
  return api.post(`/admin/cycle/update/${id}`, data);
};

export const adminGetBonusCycles = (params = {}) => {
  const query = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      query.append(key, value);
    }
  });

  const qs = query.toString();
  return api.get(`/cycles${qs ? `?${qs}` : ""}`);
};

export const adminGetBonusCycleById = (id) => {
  return api.get(`/admin/cycle/${id}`);
};

export const adminEligibleUsersList = (params = {}) => {
  const query = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      query.append(key, value);
    }
  });

  const qs = query.toString();
  return api.get(`/admin/eligible-users${qs ? `?${qs}` : ""}`);
};

export const adminProcessGift = (data = {}) => {
  return api.post("/admin/process-gift", data);
};

export const adminGetBonusHistory = (params = {}) => {
  const query = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      query.append(key, value);
    }
  });

  const qs = query.toString();
  return api.get(`/admin/bonus-history${qs ? `?${qs}` : ""}`);
};

export const myBonusDashboard = (params = {}) => {
  const query = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      query.append(key, value);
    }
  });

  const qs = query.toString();
  return api.get(`/user/my-bonus-dashboard${qs ? `?${qs}` : ""}`);
};

export const adminGetEarningStatements = (params = {}) => {
  const query = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && String(value).trim() !== "") {
      query.append(key, value);
    }
  });

  return api.get(`/admin/earning-statements${query.toString() ? `?${query.toString()}` : ""}`);
};

export const adminGetEarningStatementById = (id) => {
  return api.get(`/admin/earning-statements/${id}`);
};

export const adminProcessEarningStatementFlush = (statement_id) => {
  return api.post("/admin/earning-statements/process-flush", { statement_id });
};

export const adminGetInactiveFlushQueue = (params = {}) => {
  const query = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && String(value).trim() !== "") {
      query.append(key, value);
    }
  });

  return api.get(`/admin/earning-statements/inactive-flush-queue${query.toString() ? `?${query.toString()}` : ""}`);
};

export const adminGetEarningStatementFlushHistory = (params = {}) => {
  const query = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && String(value).trim() !== "") {
      query.append(key, value);
    }
  });

  return api.get(`/admin/earning-statements/flush-history${query.toString() ? `?${query.toString()}` : ""}`);
};

export const adminGetAllTickets = (params = {}) => {
  const query = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && String(value).trim() !== "") {
      query.append(key, value);
    }
  });

  return api.get(`/admin/tickets${query.toString() ? `?${query.toString()}` : ""}`);
};

export const getTicketById = (id) => {
  return api.get(`/ticket/${id}`);
};

export const adminUpdateTicketStatus = (id, data = {}) => {
  return api.post(`/admin/update-ticket-status/${id}`, data);
};

export const userGetMyTickets = (params = {}) => {
  const query = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && String(value).trim() !== "") {
      query.append(key, value);
    }
  });

  return api.get(`/user/my-tickets${query.toString() ? `?${query.toString()}` : ""}`);
};

export const userCreateTicket = (formData) => {
  return api.post("/user/raise-ticket", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const userCreateRefundRequest = (data = {}) => {
  return api.post("/user/refunds/create", data);
};

export const userGetMyRefundRequests = (params = {}) => {
  const query = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && String(value).trim() !== "") {
      query.append(key, value);
    }
  });

  return api.get(`/user/my-refunds${query.toString() ? `?${query.toString()}` : ""}`);
};

export const getRefundById = (id) => {
  return api.get(`/refund/${id}`);
};

export const adminGetRefundRequests = (params = {}) => {
  const query = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && String(value).trim() !== "") {
      query.append(key, value);
    }
  });

  return api.get(`/admin/refunds${query.toString() ? `?${query.toString()}` : ""}`);
};

export const adminUpdateRefundStatus = (id, data = {}) => {
  return api.post(`/admin/update-refund-status/${id}`, data);
};


export const adminExportUserReport = (params = {}) => {
  const query = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      query.append(key, value);
    }
  });

  return api.get(`/admin/users/export?${query.toString()}`, {
    responseType: "blob",
  });
};

export const adminGetUserTransactions = (id, params = {}) => {
  return api.get(`/admin/user-transactions/${id}`, { params });
};

export const adminGetCoursesByUserId = (id, params = {}) => {
  return api.get(`/admin/user-courses/${id}`, { params });
};

export const userCourseOptOut = (data) => {
  return api.post("/user/course/opt-out", data);
};

export const userCourseOptOutToggle = (data) => {
  return api.post("/user/course/opt-out-toggle", data);
};

export const requestCourseOptOutOtp = (data) => {
  return api.post("/user/course/opt-out/request-otp", data);
};

export const verifyCourseOptOutOtp = (data) => {
  return api.post("/user/course/opt-out/verify", data);
};

export const adminCourseOptOutReport = (params = {}) => {
  const query = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      query.append(key, value);
    }
  });

  return api.get(`/admin/reports/course-opt-outs?${query.toString()}`);
};

export const adminCourseOptOutExport = (format, params = {}) => {
  const query = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      query.append(key, value);
    }
  });

  const path =
    format === "pdf"
      ? "/admin/reports/course-opt-outs/export/pdf"
      : "/admin/reports/course-opt-outs/export/excel";

  return api.get(`${path}?${query.toString()}`, {
    responseType: "blob",
  });
};

export const sendKycOtp = (payload) => {
  return api.post("/kyc/send-otp", payload);
};

export const verifyKycOtp = (payload) => {
  return api.post("/kyc/verify-otp", payload);
};


export const verifyPanKyc = (payload) => {
  return api.post("/kyc/verify-pan", payload);
};

export const userMySubIdsList = (params = {}) => {
  return api.get("/user/my-ids", { params });
};

export const getUserMyTeam = (params = {}) => {
  return api.get("/user/my-team", { params });
};

export const userCheckSubIdUsername = (username) => {
  return api.get("/user/my-ids/check-username", { params: { username } });
};

export const userGetEligibleSubIdPlacements = () => {
  return api.get("/user/my-ids/eligible-placements");
};

export const userCreateSubId = (data = {}) => {
  return api.post("/user/my-ids/create", data);
};

export const userGetSubIdDetail = (customUserId) => {
  return api.get(`/user/my-ids/${customUserId}`);
};

export const userGetSubIdNetwork = (customUserId) => {
  return api.get(`/user/my-ids/${customUserId}/network`);
};

export const userUpdateSubIdBank = (customUserId, data = {}) => {
  return api.post(`/user/my-ids/${customUserId}/bank-details`, data);
};

export const userChangeSubIdPassword = (customUserId, data = {}) => {
  return api.post(`/user/my-ids/${customUserId}/change-password`, data);
};

export const userToggleSubIdStatus = (customUserId) => {
  return api.post(`/user/my-ids/${customUserId}/toggle-status`);
};

export const userDeactivateSubId = (customUserId) => {
  return api.delete(`/user/my-ids/${customUserId}`);
};

export const adminGetUserSubIds = (userId) => {
  return api.get(`/admin/user-sub-ids/${userId}`);
};

export const verifyBankByPennyDrop = (data = {}) => {
  return api.post(`/kyc/verify-bank-by-penny-drop`, data);
};


export const blockUserStatus = (payload) => {
  return api.post("/auth/block-user", payload);
};


export const userCourseCancelOptOut = (data = {}) => {
  return api.post("/user/course/cancel-opt-out", data);
};

export const getAllNotifications = () => {
  return api.get("/notifications");
};

export const getUnreadNotificationsCount = () => {
  return api.get("/unread-notifications-count");
};

export const markNotificationRead = (id) => {
  return api.post(`/notification/mark-read/${id}`);
};

export const markAllNotificationsRead = () => {
  return api.post(`/notification/mark-all-read`);
};

export const adminGetUserActivityLogs = (id, params = {}) => {
  return api.get(`/admin/user-activity-logs/${id}`, { params });
};

export const globalSearch = (search) => {
  return api.get("/global-search", {
    params: { search },
  });
};

export const adminGetSettlements = (params = {}) => {
  const query = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (
      value !== undefined &&
      value !== null &&
      String(value).trim() !== ""
    ) {
      query.append(key, value);
    }
  });

  return api.get(
    `/admin/settlements${query.toString() ? `?${query.toString()}` : ""
    }`
  );
};


export const adminGetSettlementById = (id) => {
  return api.get(`/admin/settlement/${id}`);
};

export const adminGetActivityLogs = (params = {}) => {
  return api.get("/admin/activity-logs", {
    params,
  });
};

export const getActivityLogById = (id) => {
  return api.get(`/admin/activity-logs/${id}`);
};


// Refund Settlement
export const adminRefundSettlements = (params = {}) => {
  return api.get("/admin/refund-settlements", { params });
};

export const adminImportRefundSettlements = (formData) => {
  return api.post("/admin/refund-settlements/import", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const adminExportRefundSettlements = (format) => {
  return api.get(`/admin/refund-settlements/export?format=${format}`, {
    responseType: "blob",
  });
};

// Commission Settlement
export const adminCommissionSettlements = (params = {}) => {
  return api.get("/admin/commission-settlements", { params });
};

export const adminImportCommissionSettlements = (formData) => {
  return api.post("/admin/commission-settlements/import", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const adminExportCommissionSettlements = (format) => {
  return api.get(`/admin/commission-settlements/export?format=${format}`, {
    responseType: "blob",
  });
};



// User Commission Settlement
export const userCommissionSettlements = (params = {}) => {
  return api.get("/user/commission-settlements", { params });
};

export const userExportCommissionSettlements = (format) => {
  return api.get(`/user/commission-settlements/export?format=${format}`, {
    responseType: "blob",
  });
};

// User Course Settlement
export const userCourseSettlements = (params = {}) => {
  return api.get("/user/course-settlements", { params });
};

export const userExportCourseSettlements = (format) => {
  return api.get(`/user/course-settlements/export?format=${format}`, {
    responseType: "blob",
  });
};


export default api;